/**
 * Helper function to update the state of a  in reducers
 *
 * Example usage:
 * ```
 * reducer(myAction, updateState(partialState)),
 * ```
 */
export const updateState = <State, NarrowedState extends State>(
  partialState: Partial<NarrowedState>
) =>
  function updateStateSetter(state: State): State {
    return {
      ...state,
      ...partialState,
    };
  };
